// extracted by mini-css-extract-plugin
export default {"itemsList":"ShoppingCart_itemsList__xNxO2","item":"ShoppingCart_item__OKyQG","total":"ShoppingCart_total__eAhvr"};